<template>
  <div>
    <ab-search @searchForm="localSearch" @resetForm="resetForm">
      <el-col :span="4">
        <el-form-item>
          <el-input size="mini" v-model="formSearch.accountName" placeholder="姓名"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="4">
        <el-form-item>
          <el-input size="mini" v-model="formSearch.mobile" placeholder="账号"></el-input>
        </el-form-item>
      </el-col>
    </ab-search>

    <div class="contentMem">
        <ab-list-query>
             <template #table>
                <ab-table
                    class="table"
                    ref="table"
                    stripe
                    showEdit
                    index-label="序号"
                    widths="350"
                    :column-list="columns"
                    :table-list="tableData"
                    :dataListLoading="tableLoading"
                >
                <template
                    #accountTypeDesc="scope"
                >{{ translate(scope.row.accountTypeDesc) }}</template>

                <template #operator="scope">
                    <div class="operator">
                    <el-button type="text" @click="showDialog(scope.row)">编辑</el-button>
                    <el-button
                        type="text"
                        v-if="scope.row.accountTypeDesc && !scope.row.accountTypeDesc.includes('03')"
                        class="delete-list"
                        @click="removeRow(scope.row)"
                    >删除</el-button>
                    <el-button
                        type="text"
                        v-if="scope.row.accountTypeDesc && !scope.row.accountTypeDesc.includes('03')"
                        @click="chown(scope.row)"
                    >管理员转授</el-button>
                    </div>
                </template>
                </ab-table>
             </template>
            <template #page>
                <ab-page ref="pagination" :pageTotal="pageTotal" @searchForm="searchForm"></ab-page>
            </template>
        </ab-list-query>
    </div>

    <!-- <el-dialog
      width="500px"
      title="编辑成员信息"
      v-model="dialog.show"
      @close="dialogClose"
      :close-on-click-modal="false"
    >
      <el-form :model="dialog.data" :rules="dialog.rules" label-position="top" ref="form">
        <el-form-item label="姓名" prop="accountName">
          <el-input size="mini" v-model="dialog.data.accountName" disabled></el-input>
        </el-form-item>

        <el-form-item label="e签宝账号" prop="mobile">
          <el-input size="mini" v-model="dialog.data.mobile" disabled></el-input>
        </el-form-item>

        <el-form-item label="角色" prop="accountTypeDesc">
          <el-select size="mini" v-model="dialog.data.accountTypeDesc" multiple placeholder>
            <el-option label="普通用户" value="01"></el-option>
            <el-option label="印章员" value="02"></el-option>
            <el-option label="管理员" value="03" :disabled="!dialog.data.roles.includes('03')"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer class="dialog-footer">
        <el-button type="primary" @click="confirmData" :loading="dialog.loading">确定</el-button>
        <el-button @click="dialog.show = false">取消</el-button>
      </template>
    </el-dialog> -->

    <el-drawer v-model="dialog.show" title="编辑成员信息" :destroy-on-close="true" custom-class='address-add' @close="dialogClose">
        <el-form :model="dialog.data" :rules="dialog.rules" label-position="top" ref="form">
            <el-form-item label="姓名" prop="accountName">
                <el-input size="mini" v-model="dialog.data.accountName" disabled></el-input>
            </el-form-item>

            <el-form-item label="e签宝账号" prop="mobile">
                <el-input size="mini" v-model="dialog.data.mobile" disabled></el-input>
            </el-form-item>

            <el-form-item label="角色" prop="accountTypeDesc">
                <el-select size="mini" v-model="dialog.data.accountTypeDesc" multiple placeholder>
                    <el-option label="普通用户" value="01"></el-option>
                    <el-option label="印章员" value="02"></el-option>
                    <el-option label="管理员" value="03" :disabled="!dialog.data.roles.includes('03')"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialog.show = false">取消</el-button>
                <el-button type="primary" @click="confirmData" :loading="dialog.loading">确定</el-button>
            </div>
        </template>
    </el-drawer>

  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'member-list', // 企业成员
  data () {
    return {
      formSearch: {},

      columns: [
        {
          labels: '姓名',
          props: 'accountName',
          widths: 100
        },
        {
          labels: '账号',
          props: 'mobile',
          widths: 100
        },
        {
          labels: '角色',
          props: 'accountTypeDesc',
          slot: 'slot',
          widths: 50
        }
      ],
      tableData: [],
      tableLoading: false,

      pageTotal: 0,

      dialog: {
        show: false,
        loading: false,
        data: {
          roles: []
        },
        rules: {
          accountName: [{ required: true, message: '姓名不能为空', trigger: 'change' }],
          mobile: [{ required: true, message: 'e签宝账号不能为空', trigger: 'change' }],
          accountTypeDesc: [{ required: true, message: '请选择角色', trigger: 'change' }]
        }
      },

      routeQuery: {}
    }
  },
  activated () {
    this.localSearch()
  },
  mounted () {
    this.routeQuery = Object.keys(this.$route.query).length ? this.$route.query : this.routeQuery
    // if (this.routeQuery.isIframe) {
      this.localSearch()
    // }
  },
  methods: {
    translate (array = []) {
      let role = []
      if (array) {
        array.map(code => {
          switch (code) {
            case '01':
              role.push('普通用户')
              break
            case '02':
              role.push('印章员')
              break
            case '03':
              role.push('管理员')
              break
          }
        })
      }
      return role.join('；')
    },
    localSearch () {
      this.$refs.pagination.currentChange(1)
    },
    searchForm (pages) {
      this.tableLoading = true
      this.$post('/sys/esignAccount/list', { data: this.formSearch, pageNum: pages.currentPage, pageSize: pages.pageSize })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.tableData = data.result.list
            this.pageTotal = data.result.total
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(err => {
          console.error(err)
          this.$message.error('服务器正忙，请稍后再试')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    resetForm () {
      this.formSearch = {}
    },
    showDialog (row) {
      this.dialog.data = _.cloneDeep(row)
      this.dialog.data.accountTypeDesc = this.dialog.data.accountTypeDesc || []
      this.dialog.data.roles = this.dialog.data.accountTypeDesc || []
      this.dialog.show = true
    },
    confirmData () {
      this.$refs.form.validate(success => {
        if (success) {
          this.dialog.loading = true
          this.dialog.data.accountType = this.dialog.data.accountTypeDesc.join(',')
          this.$post('/sys/esignAccount/mod', this.dialog.data)
            .then(({ data }) => {
              if (data.code === 'C0000') {
                this.$message.success(data.message)
                this.dialog.show = false
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(err => {
              console.error(err)
              this.$message.error('服务器正忙，请稍后再试')
            })
            .finally(() => {
              this.dialog.loading = false
            })
        }
      })
    },
    dialogClose () {
      this.dialog.data = { roles: [], accountTypeDesc: [] }
      this.$refs.form.clearValidate()
      this.localSearch()
    },
    removeRow (row) {
      this.$confirm('此操作将永久删除该行, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableLoading = true
        this.$post('/sys/esignAccount/del', { id: row.id })
          .then(({ data }) => {
            if (data.code === 'C0000') {
              this.$message.success(data.message)
            } else {
              this.$message.error(data.message)
            }
          })
          .catch(err => {
            console.error(err)
            this.$message.error('服务器正忙，请稍后再试')
          })
          .finally(() => {
            this.localSearch()
          })
      })
    },
    chown (row) {
      this.tableLoading = true
      this.$get('/sys/esignAccount/setAdminAccount', { id: row.id })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.$message.success(data.message)
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(err => {
          console.error(err)
          this.$message.error('服务器正忙，请稍后再试')
        })
        .finally(() => {
          this.localSearch()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer{
    text-align: center;
}
.contentMem {
    margin-top: 8px;
    background: #fff;
    ::v-deep .ab-list-query{
        .el-menu{
            display: none;
        }
        .list-content{
            padding-top: 0;
            .toolbar{
                display: none;
            }
        }
    }
}

.table {
  .operator {
    font-size: 0;
    display: flex;
  }

  .el-button--text {
    padding: 0;
  }
}
</style>
